import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, API } from "@/lib/api";
import { unlinkUser } from "@/lib/onesignal";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [settings, setSettings] = useState({ app_name: "UKerja", categories: [] });
  const [mode, setModeState] = useState(localStorage.getItem("ukerja_mode") || "user");

  const refreshUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch (e) {
      setUser(false);
      return false;
    }
  }, []);

  const loadSettings = useCallback(async () => {
    const { data } = await api.get("/public/settings");
    setSettings(data);
    document.title = `${data.app_name} - Marketplace Jasa`;
    if (data.has_favicon) {
      document.querySelectorAll("link[rel~='icon']").forEach((l) => {
        l.href = `${API}/public/favicon?v=${data.version}`;
      });
    }
  }, []);

  useEffect(() => {
    refreshUser();
    loadSettings().catch(() => {});
  }, [refreshUser, loadSettings]);

  const setMode = (m) => {
    localStorage.setItem("ukerja_mode", m);
    setModeState(m);
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    unlinkUser();
    setMode("user");
    setUser(false);
  };

  const effectiveMode = user && user.is_worker ? mode : "user";

  return (
    <AuthCtx.Provider value={{ user, setUser, refreshUser, settings, loadSettings, mode: effectiveMode, setMode, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
